import { ListingInterface, ListingsInterface } from "../../../../../../types";
import { DisplayAmount } from "../../../../../common/components/CurrencySwitch";
import { IListing } from "../../../../../common/utils/interfaces";

const SideSubSection = ({
  icon,
  title,
  description,
}: {
  icon: JSX.Element;
  title: string;
  description: string;
}) => (
  <div className="flex flex-col p-[15px] gap-y-[8px]">
    <div className="flex">
      <div>{icon}</div>
      <div className="text-[20px] text-[#066D0E]">{title}</div>
    </div>
    {/* set font weight to 300 */}
    <div className="text-[14px] font-light">
      {description}
      form.​
    </div>
  </div>
);

const PurchaseSideSection = ({ listing }: { listing?: IListing }) => (
  <section className="sm:min-w-[500px] flex flex-col gap-y-[30px] flex-1 h-full">
    <div className="card-shadow responsive_flex p-[15px] gap-x-[25px] rounded-[8px]">
      <img
        src={listing?.files?.[0]?.file}
        className="sm:w-[210px] sm:h-[170px]"
        alt=""
      />{" "}
      <div>
        <div className="text-[16px] text-[#686868] mb-[5px]">Price</div>
        <div className="text-[28px] font-semibold text-[#000000] mb-[16px]">
          {listing?.price ? (
            <DisplayAmount amount={Number(listing?.price)} />
          ) : (
            "--"
          )}
        </div>
        <div className="text-[20px] text-[#000000] mb-[5px] font-medium">
          {listing?.name || "--"}
        </div>
        <div className="text-[16px] font-light text-[#363636]">
          {`${listing?.address || "--"}`}
        </div>
      </div>
    </div>
    <div className="card-shadow flex flex-col py-[15px] px-[20px] gap-y-[10px] flex-1 min-h-0">
      <div className="flex flex-col gap-y-[4px] pb-[30px] border-b border-[#eeeeee]">
        <div className="text-[18px] font-semibold text-[#000000]">
          How it works
        </div>
        <div className="text-[16px]">
          Follow these simple steps to complete your property purchase
        </div>
      </div>
      {/* <div className="h-[400px] overflow-y-auto"> */}
      <div className="overflow-y-auto flex-1 min-h-0">
        <SideSubSection
          icon={<></>}
          title="Find Your Dream Property"
          description="Choose from a wide range of houses available on the home and abroad
        platform. View property pictures, request a virtual or Live property
        tour, and if you love the property, Simply fill out a property purchase
        form.​"
        />
        <SideSubSection
          icon={<></>}
          title="Fill The Property Purchase Form"
          description="Click on “Buy Property”, fill out the property purchase form with the important details, and an automated Invoice will be displayed and also sent to your email address.​"
        />
        <SideSubSection
          icon={<></>}
          title="Make Payment"
          description="Make a payment for the property using the payment channel on the platform"
        />
        <SideSubSection
          icon={<></>}
          title="Get Your Sales Receipt"
          description="Once Payment is confirmed, a sales receipt is generated for the purchased property from the Home and Abroad Platform. This receipt can be downloaded from your mail or from the Home and Abroad Platform.​"
        />
        <SideSubSection
          icon={<></>}
          title="Get Your Property Document And Keys"
          description="Finally, your property document and Keys will be sent to you anywhere in the world through our Logistics partners DHL or picked up from the seller by a representative of yours. You now own a home back home​"
        />
      </div>
    </div>
  </section>
);

export default PurchaseSideSection;
